export default "__VITE_ASSET__uUDUWevZ__"